export { default, IconProp } from './FontAwesome';
